export default __webpack_public_path__ + "static/media/folder.b5148876.svg";